<div>
    <div class="card paper">
        <form [formGroup]="commentForm" (ngSubmit)="onSubmit()">
            <fieldset class="form-group">
                <input type="text" class="form-control" formControlName="comment" placeholder="Add a comment">
            </fieldset>
            <button type="submit" [disabled]="isPosting">
                <span *ngIf="isPosting" class="spinner-border spinner-border-sm" role="status"
                    aria-hidden="true"></span>
                Post
            </button>
        </form>
        <details>
            <summary>Comments</summary>
            <!-- <ul class="list-group">
                <li class="list-group-item" *ngFor="let comment of oldComments">
                    <span class="title">
                        <a href="#">{{comment.userName}} </a>
                        <time>{{comment.createdAt['seconds'] * 1000 | date:'MMM-dd-yyyy HH:mm:aa' }}</time>
                        <p>{{comment.text}}</p>
                    </span>
                    <ul class="reply-list">
                        <li *ngFor="let reply of comment.replies">
                            <span class="title">
                                <a href="#">{{reply.displayName}}</a>
                                <time>{{reply.date}}</time>
                                <p>{{reply.text}}</p>
                            </span>
                        </li>
                    </ul>
                    <ul class="actions" href="#">
                        <li><a (click)="onShowReplyDialog(comment.id)" class="reply" href="javascript:;">Reply</a></li>
                    </ul>
                </li>
            </ul> -->
        </details>
        <ul id="lastComment" class="list-group">
            <li class="list-group-item" *ngFor="let comment of comments">
                <span class="title">
                    <a href="#">{{comment.userName}} </a>
                    <time>{{comment.createdAt['seconds'] * 1000 | date:'MMM-dd-yyyy HH:mm:aa' }}</time>
                    <p>{{comment.text}}</p>
                </span>
                <ul class="reply-list">
                    <li *ngFor="let reply of comment.replies">
                        <span class="title">
                            <a href="#">{{reply.displayName}}</a>
                            <time>{{reply.date}}</time>
                            <p>{{reply.text}}</p>
                        </span>
                    </li>
                </ul>
                <ul class="actions" href="#">
                    <li><a (click)="onShowReplyDialog(comment.id)" class="reply" href="javascript:;">Reply</a></li>
                </ul>
            </li>
        </ul>
    </div>

</div>

<app-reply-comment-dialog [show]="showDialog" (onDismissCallback)="onDismissDialog()" (onSubmitCallBack)="onReply($event)"></app-reply-comment-dialog>